import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCookies } from "react-cookie";

import { Button } from "../../../components/ui/button";
import {
  DialogDescription,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  Dialog,
} from "../../../components/ui/dialog";

import { navLocale } from "../../../lib/locale";

interface LogoDialogProps {
  onOpenChange: (open: boolean) => void;
  open: boolean;
}

export function LogoDialog({ onOpenChange, open }: LogoDialogProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [, setCookie] = useCookies(["logo"]);

  const handleSkip = () => {
    const expire = new Date();
    expire.setDate(expire.getDate() + 7);
    setCookie("logo", expire, {
      expires: expire,
      path: "/",
      secure: true,
    });
    onOpenChange(false);
  };

  const handleUpload = () => {
    const expire = new Date();
    expire.setDate(expire.getDate() + 7);
    setCookie("logo", expire, {
      expires: expire,
      path: "/",
      secure: true,
    });
    onOpenChange(false);
    navigate(navLocale("/account"));
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[460px] rounded-xl border border-gray-100 dark:border-white/10">
        <div className="flex flex-col grow-0 gap-y-5">
          <DialogHeader>
            <DialogTitle>{t("auth-logo-title")}</DialogTitle>
            <DialogDescription>{t("auth-logo-message")}</DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button
              className="flex flex-row h-8 w-24 px-3 items-center rounded-lg text-xs text-white bg-[#ef8262] hover:bg-[#ef8262]/80"
              onClick={() => handleSkip()}
              variant="headless"
              size="headless"
              type="button"
            >
              {t("auth-logo-submit-1")}
            </Button>
            <Button
              className="flex flex-row h-8 w-24 px-3 items-center rounded-lg text-xs text-white bg-[#0195c5] hover:bg-[#0195c5]/80"
              onClick={() => handleUpload()}
              variant="headless"
              size="headless"
              type="button"
            >
              {t("auth-logo-submit-2")}
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
